import { useMutation, useQuery } from 'react-query';
import { RemotePhsPaccRepo } from '@repository/phs/pacc/PhsPaccRepo';
import { PaccFeedbackSaveRq } from '@domain/rq/phs/pacc/result/PaccFeedbackSaveRq';

const remotePhsPaccRepo = new RemotePhsPaccRepo();

const phsPaccFeedbackKeys = ['phs', 'pacc', 'feedback'];

export const usePHSPACCResultsFeedbackExists = (sn: number) => {
  return useQuery(
    [...phsPaccFeedbackKeys, 'feedbackExists', sn],
    async () => {
      const { data } = await remotePhsPaccRepo.fetchPHSPACCResultsFeedbackExists(sn);
      return data;
    },
    {
      enabled: !!sn,
    },
  );
};

export const usePHSPACCResultsFeedback = (rq: PaccFeedbackSaveRq, onSuccess: () => void) => {
  return useMutation(() => remotePhsPaccRepo.fetchPHSPACCResultsFeedback(rq), {
    onSuccess: onSuccess,
  });
};
